// The "folder" page-level tab recipe, canonicalized from apps/web's
// InboxTabsFilter/Account (`apps/web/DESIGN_SYSTEM.md` § Tabs). Chakra-free —
// plain class strings a consumer spreads into its own `const stylesheet`.
// `.tsx` extension is deliberate: both apps' Tailwind `content` globs only
// scan `libs/ui/src/**/*.tsx`, not `*.ts`.
export const PAGE_TABS_STYLES = {
  tabList: 'gap-1 md:gap-2 z-10 border-semantic-border w-full md:w-fit',
  tab: 'relative z-0 font-medium text-sm px-[13px] md:px-4 py-2 rounded-t-semantic bg-semantic-bg-subtle',
  tabSelected:
    'relative z-10 font-medium text-sm px-2 md:px-4 py-2 rounded-t-semantic bg-semantic-bg-surface text-semantic-text-accent',
  tabContent: 'flex items-center gap-1',
  // Load-bearing dark: fixup carried over from Account/InboxTabsFilter — see
  // libs/LIBRARIES.md § ui for why it stays despite the no-dark:-on-semantic-
  // tokens rule.
  tabIndicator:
    'absolute bottom-0 left-0 right-0 h-[2px] rounded-full bg-semantic-border-accent dark:bg-semantic-text-secondary',
  tabPanel: 'p-0 focus:outline-none w-full',
} as const;

// The underline page-level tab recipe, canonicalized from web's
// AgentDelegationConversationModalTabs (`apps/web/DESIGN_SYSTEM.md` § Tabs).
// No surface/indicator — the active tab's own border stands in for one, so
// this fits a tab strip that sits over a page background rather than a
// joined "folder" container.
export const UNDERLINE_TABS_STYLES = {
  tabList: 'gap-4.5 border-b border-semantic-border',
  tab: 'shrink-0 py-2.5 font-medium text-semantic-text-secondary whitespace-nowrap border-b-2 border-transparent',
  tabSelected:
    'shrink-0 py-2.5 font-bold text-semantic-text-primary whitespace-nowrap border-b-2 border-semantic-border-accent',
  tabPanel: 'pt-5 focus:outline-none w-full px-0 pb-0',
  // Font size is split out so a consumer picks exactly one: two size
  // utilities on the same element resolve by CSS declaration order, not
  // class order, so appending one after the other is unsafe.
  textCompact: 'text-[12.5px]',
  textPage: 'text-sm',
} as const;

// The segmented pill switch, canonicalized from apps/web's FlowsHubHeader
// (`apps/web/DESIGN_SYSTEM.md` § Tabs): a rounded track with the active
// segment raised on the elevated surface color.
export const SEGMENTED_TABS_STYLES = {
  track:
    'inline-flex items-center gap-1 p-1 rounded-full bg-semantic-bg-subtle shrink-0',
  segment:
    'px-4 py-1.5 rounded-full text-sm font-medium text-semantic-text-secondary hover:text-semantic-text-primary transition-colors cursor-pointer whitespace-nowrap',
  segmentActive:
    'px-4 py-1.5 rounded-full bg-semantic-bg-elevated text-semantic-text-primary shadow-sm text-sm font-medium whitespace-nowrap cursor-pointer transition-colors',
} as const;
